import React from "react";

interface CheckCircleIconProps {
  size?: number;
}

export default function CheckCircleIcon({
  size = 16,
}: Readonly<CheckCircleIconProps>) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M9.63118 1.50923C11.8922 0.998396 14.2579 1.23185 16.3753 2.17525C16.7535 2.34391 16.9238 2.7872 16.7552 3.16548C16.5866 3.54364 16.1432 3.71376 15.765 3.54537C13.9431 2.73363 11.9077 2.53268 9.96224 2.97213C8.01663 3.41171 6.26506 4.46856 4.96907 5.98482C3.67313 7.50112 2.90207 9.39586 2.77083 11.3862C2.6397 13.3763 3.15508 15.3556 4.24056 17.0288C5.32615 18.7019 6.92346 19.9801 8.79427 20.6713C10.6653 21.3625 12.7106 21.4302 14.6234 20.8647C16.536 20.2991 18.2143 19.1301 19.4085 17.5327C20.6027 15.9353 21.249 13.9948 21.2503 12.0004V11.0805C21.2503 10.6663 21.5861 10.3305 22.0003 10.3305C22.4145 10.3306 22.7503 10.6664 22.7503 11.0805V12.0004L22.7415 12.435C22.6528 14.5994 21.9117 16.6907 20.6107 18.4311C19.2227 20.2877 17.2711 21.6459 15.0482 22.3032C12.8253 22.9604 10.4492 22.8819 8.27474 22.0786C6.10037 21.2752 4.24347 19.7897 2.98177 17.8452C1.72034 15.9007 1.12137 13.6003 1.27376 11.2876C1.42628 8.9745 2.32238 6.77238 3.82845 5.01021C5.33458 3.24804 7.37007 2.02013 9.63118 1.50923ZM21.4701 3.4692C21.7628 3.17678 22.2377 3.17679 22.5306 3.4692C22.8233 3.76186 22.823 4.23677 22.5306 4.52974L12.5306 14.5395C12.39 14.6802 12.1992 14.7591 12.0003 14.7592C11.8014 14.7592 11.6107 14.6802 11.4701 14.5395L8.47005 11.5395C8.17743 11.2466 8.17725 10.7718 8.47005 10.479C8.76289 10.1866 9.23782 10.1865 9.5306 10.479L11.9993 12.9477L21.4701 3.4692Z"
        fill="currentColor"
      />
    </svg>
  );
}
